import { CurrencyRef } from "src/models/currencies";
import { LegalEntityClientRef } from "src/models/legal-entity-clients";
import { LegalEntityVendorRef } from "src/models/legal-entity-vendors";
import { LegalEntityOptionValue } from "../../containers/Quickfilters/LegalEntityQuickfilter/interfaces";
import { CompanyLegalEntityDTO } from "../../models/company-accounts/company-legal-entities";
import { DocumentsReportCategoryDTO } from "../../models/documents/documents-reports/documents-report-category-dto";
import { AmountDetailsProps } from "../../views/documents-reports/InvoiceTrackingReport/InvoiceTrackingReportAmountActions";

export interface DynamicColumn {
  name: string;
  field: string;
  Component?: React.ComponentType<{
    value: string;
    client?: LegalEntityClientRef | null;
    currency?: CurrencyRef | null;
    vendor?: LegalEntityVendorRef | null;
  }>;
}
export interface Props {
  filter: string;
  documentReportId: string;
  allReportsAlwaysOn?: boolean;
  loadItemsPath?: "/GetDocumentsReport" | "/GetInvoicesTrackingReport" | "/GetEmployeeGroupDocumentsReport";
  authDomainToHideDoc?: string | null;
  authDomainToSetVerified?: string | null;
  allowAuthorizations?: string[] | null;
  legalEntityFilter?: Filter;
  year?: number;
  quickFilters?: JSX.Element;
  tableTitle?: string;
  showPeriodTypeQF?: boolean;
  dynamicColumn?: DynamicColumn;
  screen?: ScreenReport;
  AmountDetails?: React.ComponentType<AmountDetailsProps>;
}

interface Filter {
  legalEntityOption: LegalEntityOptionValue | null;
  selectedLegalEntity?: CompanyLegalEntityDTO | null;
}

export interface State {
  items: DocumentsReportCategoryDTO[];
  loading: boolean;
  error: string;
}

export enum ScreenReport {
  invoiceTracking = "invoiceTracking",
}
